import { combineReducers } from "redux";
import * as actionTypes from "~/store/action_types";

const showThankYou = (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACCOUNT_SETTINGS_SUCCESS: {
      if (action && action.response && action.response.status && action.response.status.is_suspended) {
        return true;
      }
      return state;
    }
    case actionTypes.SET_THANK_YOU_PAGE_VISIBILITY: {
      return action.visible;
    }
    default:
      return state;
  }
};

export default combineReducers({
  showThankYou,
});
